export default "__VITE_ASSET__BUd$XNjy__"